import {
  DevicePhoneMobileIcon,
  ArrowLeftOnRectangleIcon,
  CurrencyDollarIcon
} from '@heroicons/react/24/outline'

import { useHeaderConfig } from 'components/Header/HeaderProvider/useHeaderConfig'

import SubMenuItem from './SubMenuItem'

const SubMenuItemsTrucks = () => {
  const { truckDashboardHeaderUrl } = useHeaderConfig()

  return (
    <>
      <SubMenuItem
        description={
          <p>
            <a
              className="p-4 text-orange-500 hover:text-orange-600 underline"
              href="https://itunes.apple.com/us/app/best-food-trucks-bft/id1354908972"
              rel="noopener noreferrer"
              target="_blank"
            >
              iOS
            </a>
            <a
              className="p-4 text-orange-500 hover:text-orange-600 underline"
              href="https://play.google.com/store/apps/details?id=com.bft"
              rel="noopener noreferrer"
              target="_blank"
            >
              Android
            </a>
          </p>
        }
        Icon={DevicePhoneMobileIcon}
        title="Download the Truck App"
      />
      <SubMenuItem
        description="Learn how BFT can grow your business"
        href="/trucks"
        Icon={CurrencyDollarIcon}
        title="Benefits of BFT"
      />
      <SubMenuItem
        description=""
        href={truckDashboardHeaderUrl('/')}
        Icon={ArrowLeftOnRectangleIcon}
        title="Login / Sign up"
      />
    </>
  )
}
export default SubMenuItemsTrucks
